import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo } from 'react'
// import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
import { SHOW_COLLECTIONS_FOR_ALL, THEME } from 'src/config/config'

interface BreadcrumbProps {
  subject?: string
  subjectRoute?: string
  subtopic?: string
  subtopicRoute?: string
  subtitle?: string
  className?: string
}

const CompatibleLink = dynamic(
  () => import('src/components/CompatibleLink/CompatibleLink').then((mod) => mod.CompatibleLink),
  {
    suspense: true,
    loading: () => <div className="loading-placeholder"></div>,
  },
)

/**
 * Primary UI component for user interaction
 */
export const Breadcrumb: React.FC<BreadcrumbProps> = memo(
  ({ subject, subjectRoute, subtopic, subtopicRoute, subtitle, className, ...props }) => {
    return (
      <div className="flex flex-row px-5 sm:px-0 justify-center items-center w-full">
        <div
          className={cn(
            '!max-w-[1100px] w-full flex flex-row items-center ',
            {
              'px-5': THEME === 'ilta',
            },
            SHOW_COLLECTIONS_FOR_ALL == 'true' ? ' mt-[27px]' : ' mt-[0.9375rem] py-2',
          )}
        >
          <div className={cn('flex', 'flex-row', 'gap-4', className)} {...props}>
            {subject && (
              <span
                className={cn(
                  'text-textdark font-primary font-bold tracking-normal cursor-pointer',
                  {
                    '!font-medium': THEME === 'ilta',
                  },
                  SHOW_COLLECTIONS_FOR_ALL == 'true' ? 'text-[13px]' : 'text-[15px]',
                )}
              >
                <CompatibleLink href={subjectRoute ? subjectRoute : '#'}>{subject}</CompatibleLink>
              </span>
            )}
            {subject && subtopic && (
              <span
                className={cn('text-textdark font-primary font-bold text-[13px] tracking-normal', {
                  '!font-medium': THEME === 'ilta',
                })}
              >
                /
              </span>
            )}
            {subtopic && (
              <span
                className={cn('text-textdark font-primary font-bold text-[13px] tracking-normal cursor-pointer', {
                  '!font-medium': THEME === 'ilta',
                })}
              >
                <CompatibleLink href={subtopicRoute ? subtopicRoute : '#'}>{subtopic.toUpperCase()}</CompatibleLink>
              </span>
            )}
            {subject && subtitle && (
              <span
                className={cn('text-textdark font-primary font-bold text-[13px] tracking-normal', {
                  '!font-medium': THEME === 'ilta',
                })}
              >
                /
              </span>
            )}
            {subtitle && (
              <span
                className={cn('text-textdark font-primary text-[13px] tracking-normal', {
                  '!font-medium': THEME === 'ilta',
                })}
              >
                {subtitle.toUpperCase()}
              </span>
            )}
            {!subject && !subtopic && (
              <span
                className={cn('text-textdark font-primary text-[13px] tracking-normal', {
                  '!font-medium': THEME === 'ilta',
                })}
              >
                {subtitle?.toUpperCase()}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  },
)
